import { useQuery } from "@tanstack/react-query";
import { getOrderCooldown } from "../api/getOrderCooldown";

export const useGetOrderCooldown = () => {
  const {
    data: cooldown,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["getOrderCooldown"],
    queryFn: getOrderCooldown,
    refetchOnWindowFocus: false,
    refetchInterval: 1000,
  });
  return { isLoading, cooldown, isError, error };
};
